import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";

const Terms = (props) => {
  const navigation = useNavigate();

  return (
    <Box
      sx={{
        backgroundImage: "url(./mainbackground.svg)",
        backgroundSize: "cover",
        height: "100vh",
      }}
    >
      <Grid container>
        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            margin: 8,
            height: "75vh",
            borderRadius: 5,
            boxShadow: 10,
            padding: 2,
          }}
        >
          <Grid item sm={12} md={12}>
            <Grid
              container
              sx={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid item sx={{ display: "flex" }}>
                <IconButton
                  onClick={() => {
                    navigation(-1);
                  }}
                >
                  <NavigateBeforeIcon
                    sx={{
                      fontSize: "1.8rem",
                      color: "#A9A9A9",
                      "@media (min-width: 1636px)": {
                        fontSize: "3rem",
                      },
                    }}
                  />
                </IconButton>
                <Typography
                  sx={{
                    mt: 1,
                    color: "primary.main",
                    fontWeight: "900",
                    fontSize: "1.2rem",
                    "@media (min-width: 1636px)": {
                      fontSize: "2rem",
                    },
                  }}
                >
                  Terms of use
                </Typography>
              </Grid>
              <Grid item sx={{ textAlign: "right", pr: 4 }}>
                <img
                  src={require("../../assets/logo.png")}
                  alt="Vocablab"
                  loading="lazy"
                  width="15%"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={12} md={12}>
            <Box sx={{ px: 2, py: 2, textAlign: "justify" }}>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "0.8em",
                  pl: 4,
                  pr: 4,
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                The Vocablab applications are offered to primarily server its
                clientele with support and services on condition that the same
                are used strictly for the purpose and the user explicitly
                promise not to use the applications for any purpose that is
                unlawful or prohibited by these Terms, or any other purpose not
                reasonably intended by Wordsworth.
              </Typography>
              <Typography
                sx={{
                  color: "primary.main",
                  fontSize: "0.8em",
                  pt: 2,
                  pl: 4,
                  pr: 4,
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                Vocablab ELT reserves the right, in its sole discretion, to
                change, limit, or discontinue and aspect, content or feature of
                its application, as well as any aspect of pertaining to the use
                of the application.
              </Typography>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </Box>
  );
};

export default Terms;
